// Keep subsecond play time across visibility/page-cache pauses. The clock is monotonic.
export function createSolveClock(initialSeconds = 0, now: () => number = () => performance.now()) {
  let elapsedMs = Math.max(0, initialSeconds) * 1000;
  let startedAt: number | null = null;
  const milliseconds = () => elapsedMs + (startedAt == null ? 0 : Math.max(0, now() - startedAt));

  return {
    seconds: () => Math.floor(milliseconds() / 1000),
    resume() {
      if (startedAt == null) startedAt = now();
    },
    pause() {
      elapsedMs = milliseconds();
      startedAt = null;
    },
    ensureSeconds(seconds: number) {
      elapsedMs += Math.max(0, seconds * 1000 - milliseconds());
    }
  };
}
